<template>
  <transition name="lib-bar">
    <div v-if="count" class="lib-bar">
      <span class="lib-bar__badge">{{ count }}</span>
      <span class="lib-bar__text">
        <strong>Đã chọn {{ count }} bài tập</strong>
        <small>Từ {{ categoryCount }} danh mục khác nhau</small>
      </span>
      <button type="button" class="lib-bar__ghost" @click="$emit('open')">
        <i class="el-icon-arrow-up"></i> Xem danh sách
      </button>
      <button type="button" class="lib-bar__link" @click="$emit('clear')">Bỏ chọn</button>
      <button type="button" class="lib-bar__primary" @click="$emit('assign')">
        <i class="el-icon-s-promotion"></i> Giao bài ({{ count }})
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LibrarySelectionBar',

  props: {
    count: { type: Number, default: 0 },
    categoryCount: { type: Number, default: 0 }
  }
}
</script>

<style lang="scss" scoped>
$green: #1cab36;

.lib-bar {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 2000;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 10px 10px 16px;
  border-radius: 12px;
  background: #13261a;
  color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: $green;
    font-weight: 700;
    font-size: 13px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    margin-right: 24px;

    strong {
      font-size: 14px;
    }

    small {
      color: #9fb3a6;
      font-size: 11px;
    }
  }

  button {
    border: 0;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 14px;
    cursor: pointer;
  }

  &__ghost {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
  }

  &__link {
    background: transparent;
    color: #d1dbd4;
  }

  &__primary {
    background: $green;
    color: #fff;
    font-weight: 600;
  }
}

.lib-bar-enter-active,
.lib-bar-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.lib-bar-enter,
.lib-bar-leave-to {
  opacity: 0;
  transform: translate(-50%, 12px);
}
</style>
